var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 100,
    height: 20,
    fill: "#FFD700",
    stroke: "#DAA520",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 30,
    height: 40,
    fill: "#F0C000",
    stroke: "#B8860B",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 10,
    width: 10,
    height: 20,
    fill: "#FF0000",
    stroke: "#8B0000",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 15,
    width: 30,
    height: 10,
    fill: "#FF0000",
    stroke: "#8B0000",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 3,
    fill: "#8B0000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 3,
    fill: "#8B0000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 10,
    x2: 55,
    y2: 10,
    stroke: "#8B0000",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 15,
    x2: 65,
    y2: 15,
    stroke: "#8B0000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.81e174a203264c1ec302300df233a379.svg";
export { ForwardRef as ReactComponent };